import * as Sentry from "@sentry/react";
import { config } from "../Constants";
import { toCamel } from '../helper/reponseFormatter';

interface LogInfo {
  level: Sentry.SeverityLevel,
  message: string,
  timestamp: number,
  extra?: { [key: string]: any },
}

const apiClient = async (url: RequestInfo | URL, options: RequestInit = {}, logInfo?: Partial<LogInfo> ) => {
  try {
    // Reset idle timer on API call (if not in warning state)
    if (typeof window !== 'undefined' && (window as any).__resetIdleTimer) {
      try {
        (window as any).__resetIdleTimer();
      } catch (err) {
        // Silently fail if timer reset fails
      }
    }
    
    const response = await fetch(config + url, options);
    if (!response.ok) {
      const res = {
        status: response.status,
        statusText: response.statusText,
        url: response.url,
      }
      const resp = await response.json().then(json => {
        const errors = JSON.stringify(json.errors)
        return { ok: false, ...res, ...json, errors }
      }).catch(err => {
        return { ok: false, ...res }
      })
      console.error("Fetch Error: ", { url, response: resp })
     //alert("Fetch Error: " + url)
      Sentry.captureMessage(`Fetch Error: ${url}`, {
        level: 'error',
        extra: {
          url,
          options,
          responseData: resp,
        }
      })
      return resp as any
    }
    if (logInfo) {
      Sentry.captureEvent({
        message: logInfo.message || '',
        level: logInfo.level || 'info',
        extra: logInfo.extra || {},
      })
    }
    try {
      const rawJson = await response.clone().json()
      return toCamel(rawJson) as any;
    } catch (err) {
      // response type is File (api: '/StateReports/UpdateBr18')
      return response
    }
  } catch (error: any) {
    //alert("Unexpected error during fetch: " + url)
    Sentry.captureMessage('Unexpected error during fetch: ', {
      level: 'error',
      extra: {
        url,
        options,
      }
    })
    return
    // throw error
  }
}

export {
  apiClient
}